// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
//@constants
const actionTypes = require('constants/actionTypes');
const { NOT_ALLOWED_NEW_OVERDRAFT_LIMIT_CHANGE_COUNTRIES } = require('constants/flagBasedFeatures');
const { WIZARD_FIRST_STEP, WIZARD_SECOND_STEP, WIZARD_THIRD_STEP, OVERDRAFT_LOAN_STANDARD, OVERDRAFT_LOAN_SUBTYPE, OVERDRAFT_LOAN_TYPE, OVERDRAFT_PRECONTRACTUAL_LIMIT, OVERDRAFT_CONTRACT_LIMIT, NA } = require('constants/index');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { formatText } = require('core/i18n').i18n;

const setLimit = limit => dispatch => {
    dispatch({
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_LIMIT,
        payload: {
            limit
        }
    });

};
const setNewFFLimit = limit => dispatch => {
    dispatch({
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_NEW_SET_LIMIT,
        payload: {
            limit
        }
    });
};
const setVisibleStep = step => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_VISIBLE_STEP,
    payload: {
        step
    }
})
const setOperationProcessIdInit = ({ operationProcessId }) => {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_INIT,
        payload: {
            operationProcessId
        }
    };
};
const setInitLimit = ({ newLimit }) => {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_LIMIT_INIT,
        payload: {
            newLimit
        }
    };
};
const setOperationProcessIdInitContract = ({ operationProcessId }) => {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_INIT_CONTRACT,
        payload: {
            operationProcessId
        }
    };
};
const setTaeTinInit = response => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_TAE_TIN,
    payload: {
        response
    }
})
const setDocumentIne = ({ base64Document, temporaryDocumentId }) => {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_INE,
        payload: {
            base64Document,
            temporaryDocumentId
        }
    };
};
const setDocumentPolicy = ({ base64Document, temporaryDocumentId }) => {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_POLICY,
        payload: {
            base64Document,
            temporaryDocumentId
        }
    };
};
const setDocumentPolicyError = () => {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SET_POLICY_ERROR

    };
};
function overdraftPrintInit() {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_PRINT_INIT
    };
}
function overdraftCheckedRadioButton(check) {
    return {

        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_CHECK_RADIO_BUTTON,
        payload: {
            check,
        },
    };
}
function preGrantedCreditVariationUpdateConfirmationCheckbox(check) {
    return {

        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_UPDATE_CONFIRMATION,
        payload: {
            check,
        },
    };
}
function preGrantedCreditVariationSendMailSuccess() {
    return {

        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SEND_MAIL_SUCCESS,

    };
}
function updateConfirmationCheck() {
    return {

        type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SEND_MAIL_CHECKBOX,

    };
}
const updateConfirmationCheckbox = () => (dispatch, getState) => {
    const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
    const confirmationCheckCc = immCreditPregrantedLimitVariation.get('confirmationCheckCc')

    !confirmationCheckCc && dispatch(getOverdraftInitContract());
    dispatch(updateConfirmationCheck())

}
const onHandleChangeCheckBoxCC = () => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_CHECK_CC,
});
const getOverdraftInitTinTae = () => (dispatch, getState) => {
    const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
    const creditId = immCreditPregrantedLimitVariation.get('creditId')
    const immAccount = getState().accounts.getIn(['byId', creditId]);
    const newLimit = immCreditPregrantedLimitVariation.get('newLimit')
    const initLimit = immCreditPregrantedLimitVariation.get('initLimit')
    const tinTaeParams = {
        query: {
            type: immAccount.get('newProduct'),
            subtype: immAccount.get('accountType')
        }
    }

    APIPost({
        params: tinTaeParams,
        dispatch,
        url: apiURLBuilder.getURL('getAccountTinTae', { contractNumber: immAccount.get('contractNumber') }),
    })
        .then(response => {
            dispatch(setTaeTinInit(response))
            initLimit !== newLimit && dispatch(getOverdraftInit());
        }).catch(response => {
            if (!!response.error) {
            } else {
                throw response;
            }
        });
}
const getINEDocument = ({ operationProcessId }) => (dispatch, getState) => {
    const globalParams = getState().globalVariables.getIn(['variables', 'parameters'])
    const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
    const creditId = immCreditPregrantedLimitVariation.get('creditId')
    const immAccount = getState().accounts.getIn(['byId', creditId]);
    const newLimit = immCreditPregrantedLimitVariation.get('newLimit')
    const tin = globalParams.getIn(['proteccion_descubierto', 'tin']).slice(0, -1);
    const tae = globalParams.getIn(['proteccion_descubierto', 'tae']).slice(0, -1);
    const monthlyTin = globalParams.getIn(['proteccion_descubierto', 'tin_mensual']).slice(0, -1);
    const ibanComplex = immAccount.get('ibanComplex');
    const account = `${ibanComplex.get('pais')}${ibanComplex.get('digitodecontrol')}${ibanComplex.get('codbban')}`;
    const taeAccount = immCreditPregrantedLimitVariation.get('debtorTae');
    const tinAccount = immCreditPregrantedLimitVariation.get('debtorTin');

    const params = {
        query: {
            amount: newLimit,
            tae,
            tin,
            monthlyTin,
            account,
            taeAccount,
            tinAccount,
            operationProcessId
        }
    }
    APIPost({ params, dispatch, url: apiURLBuilder.getURL('getOverdraftLoanINEDocument') })
        .then(response => {
            dispatch(setDocumentIne({ base64Document: response.base64Document, temporaryDocumentId: response.temporaryDocumentId }));

        })
        .catch(response => {
            if (!!response.error) {
            } else {
                throw response;
            }
        });
}
const getOverdraftInit = () => (dispatch, getState) => {
    const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
    const globalParams = getState().globalVariables.getIn(['variables', 'parameters'])
    const creditId = immCreditPregrantedLimitVariation.get('creditId')
    const immAccount = getState().accounts.getIn(['byId', creditId]);
    const newLimit = immCreditPregrantedLimitVariation.get('newLimit')
    const initLimit = immCreditPregrantedLimitVariation.get('initLimit')
    const tin = globalParams.getIn(['proteccion_descubierto', 'tin']).slice(0, -1);
    const tae = globalParams.getIn(['proteccion_descubierto', 'tae']).slice(0, -1);
    const monthlyTin = globalParams.getIn(['proteccion_descubierto', 'tin_mensual']).slice(0, -1);
    const ibanComplex = immAccount.get('ibanComplex');
    const account = `${ibanComplex.get('pais')}${ibanComplex.get('digitodecontrol')}${ibanComplex.get('codbban')}`;
    const tinAccount = immCreditPregrantedLimitVariation.get('debtorTin');
    const taeAccount = immCreditPregrantedLimitVariation.get('debtorTae');
    const contractNumberAccount = ibanComplex.get('codbban');


    const params = {
        query: {
            amount: newLimit,
            product: {
                standard: OVERDRAFT_LOAN_STANDARD,
                subType: OVERDRAFT_LOAN_SUBTYPE,
                type: OVERDRAFT_LOAN_TYPE
            },
            tin,
            monthlyTin,
            account,
            taeAccount,
            tinAccount,
            processType: OVERDRAFT_PRECONTRACTUAL_LIMIT,
            contractNumberAccount,
            tae
        }
    }
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            initLimit !== newLimit && dispatch(setInitLimit({ newLimit }))
            dispatch(setOperationProcessIdInit({ operationProcessId: response.operationProcessId }))
            dispatch(getINEDocument({ operationProcessId: response.operationProcessId }))


        })
        .catch(response => {
            if (!!response.error) {
                dispatch(setDocumentPolicyError());
            } else {
                throw response;
            }
        });
};
const sendOverDraftSimpleEmail = () => (dispatch, getState) => {
    const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
    const creditId = immCreditPregrantedLimitVariation.get('creditId')

    const immAccount = getState().accounts.getIn(['byId', creditId]);
    const ibanComplex = immAccount.get('ibanComplex');
    const contractNumberAccount = ibanComplex.get('codbban');
    const operationProcessId = immCreditPregrantedLimitVariation.get('operationProcessIdInit')
    const acceptanceText = __CONTACT_CENTER__ && !isPrintOfficeMode() ? NA :
        __CONTACT_CENTER__ && isPrintOfficeMode() ? formatText('overdraftProtectionLoan-acceptanceTextCC')
            : formatText('overdraftProtectionLoan-pdfCheckboxAlreadyRead')
    const scrollDown = immCreditPregrantedLimitVariation.get('scrollDown');
    const documentId = immCreditPregrantedLimitVariation.get('fileINEDocumentId');

    const params = {
        query: {
            mailType: OVERDRAFT_PRECONTRACTUAL_LIMIT,
            documentId,
            scrollDown,
            product: {
                standard: OVERDRAFT_LOAN_STANDARD,
                subType: OVERDRAFT_LOAN_SUBTYPE,
                type: OVERDRAFT_LOAN_TYPE,
            },
            contractNumberAccount,
            operationProcessId,
            acceptanceText
        }

    };
    APIPost({
        dispatch,
        endpoint: 'sendOverDraftSimpleEmail',
        params
    })
        .then(() => {

            dispatch(preGrantedCreditVariationSendMailSuccess());

        })
        .catch(response => {
            if (!!response.error) {
            } else {
                throw response;
            }
        });
}
const getPolicyDocument = ({ operationProcessId, contractNumberAccount }) => (dispatch, getState) => {
    const globalParams = getState().globalVariables.getIn(['variables', 'parameters'])
    const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
    const creditId = immCreditPregrantedLimitVariation.get('creditId')
    const immAccount = getState().accounts.getIn(['byId', creditId]);
    const newLimit = immCreditPregrantedLimitVariation.get('newLimit')
    const tin = globalParams.getIn(['proteccion_descubierto', 'tin']).slice(0, -1);
    const tae = globalParams.getIn(['proteccion_descubierto', 'tae']).slice(0, -1);
    const monthlyTin = globalParams.getIn(['proteccion_descubierto', 'tin_mensual']).slice(0, -1);
    const ibanComplex = immAccount.get('ibanComplex');
    const account = `${ibanComplex.get('pais')}${ibanComplex.get('digitodecontrol')}${ibanComplex.get('codbban')}`;
    const taeAccount = immCreditPregrantedLimitVariation.get('debtorTae');
    const tinAccount = immCreditPregrantedLimitVariation.get('debtorTin');

    const params = {
        query: {
            amount: newLimit,
            tae,
            tin,
            monthlyTin,
            account,
            taeAccount,
            tinAccount,
            operationProcessId,
            contractNumberAccount

        }
    }
    APIPost({ params, dispatch, url: apiURLBuilder.getURL('contractDocumentPolicy') })
        .then(response => {
            dispatch(setDocumentPolicy({ base64Document: response.base64Document, temporaryDocumentId: response.temporaryDocumentId }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(setDocumentPolicyError());

            } else {
                throw response;
            }
        });
}
const getOverdraftInitContract = () => (dispatch, getState) => {
    const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
    const globalParams = getState().globalVariables.getIn(['variables', 'parameters'])
    const creditId = immCreditPregrantedLimitVariation.get('creditId')
    const immAccount = getState().accounts.getIn(['byId', creditId]);
    const newLimit = immCreditPregrantedLimitVariation.get('newLimit')
    const tin = globalParams.getIn(['proteccion_descubierto', 'tin']).slice(0, -1);
    const tae = globalParams.getIn(['proteccion_descubierto', 'tae']).slice(0, -1);
    const monthlyTin = globalParams.getIn(['proteccion_descubierto', 'tin_mensual']).slice(0, -1);
    const ibanComplex = immAccount.get('ibanComplex');
    const account = `${ibanComplex.get('pais')}${ibanComplex.get('digitodecontrol')}${ibanComplex.get('codbban')}`;
    const tinAccount = immCreditPregrantedLimitVariation.get('debtorTin');
    const taeAccount = immCreditPregrantedLimitVariation.get('debtorTae');
    const contractNumberAccount = ibanComplex.get('codbban');
    const operationProcessIdInit = immCreditPregrantedLimitVariation.get('operationProcessIdInit');

    const params = {
        query: {
            amount: newLimit,
            attachedEvidences: [operationProcessIdInit],
            product: {
                standard: OVERDRAFT_LOAN_STANDARD,
                subType: OVERDRAFT_LOAN_SUBTYPE,
                type: OVERDRAFT_LOAN_TYPE
            },
            tin,
            monthlyTin,
            account,
            taeAccount,
            tinAccount,
            processType: OVERDRAFT_CONTRACT_LIMIT,
            contractNumberAccount,
            tae
        }
    }
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            dispatch(setOperationProcessIdInitContract({ operationProcessId: response.operationProcessId }))
            dispatch(getPolicyDocument({ operationProcessId: response.operationProcessId, contractNumberAccount }))


        })
        .catch(response => {
            if (!!response.error) {
                dispatch(setDocumentPolicyError());
            } else {
                throw response;
            }
        });
};
const validateStep = step => (dispatch, getState) => {
    const creditPregrantedLimitVariationFeatureFlag = getState().flagBasedFeatures
    const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
    const newFF = creditPregrantedLimitVariationFeatureFlag.get(NOT_ALLOWED_NEW_OVERDRAFT_LIMIT_CHANGE_COUNTRIES)
    const fileINEDocument = immCreditPregrantedLimitVariation.get('fileINEDocument')
    const newLimit = immCreditPregrantedLimitVariation.get('newLimit')
    const initLimit = immCreditPregrantedLimitVariation.get('initLimit')
    const sendMail = immCreditPregrantedLimitVariation.get('sendMail')
    const operationProcessIdInitContract = immCreditPregrantedLimitVariation.get('operationProcessIdInitContract')

    if (newFF) {
        if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {

            dispatch({
                type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_VALIDATE_NEW_STEP,
                payload: {
                    step,
                    validStep: 0
                }
            });
            const valid = getState().creditPregrantedLimitVariation.getIn(['newSteps', 0, 'valid']);

            if (valid) {
                dispatch(setVisibleStep(WIZARD_SECOND_STEP));
            }
            if (step === WIZARD_FIRST_STEP) {
                if (!fileINEDocument) {
                    dispatch(getOverdraftInitTinTae())


                }
            } else if (step === WIZARD_SECOND_STEP) {
                dispatch({
                    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_VALIDATE_NEW_STEP,
                    payload: {
                        step,
                        validStep: WIZARD_FIRST_STEP

                    }
                });
                dispatch(setVisibleStep(WIZARD_THIRD_STEP));
                sendMail && initLimit !== newLimit && dispatch(sendOverDraftSimpleEmail());
            }
        } else {


            dispatch({
                type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_VALIDATE_NEW_STEP,
                payload: {
                    step,
                    validStep: 0
                }
            });
            const valid = getState().creditPregrantedLimitVariation.getIn(['newSteps', 0, 'valid']);

            if (valid) {
                dispatch(setVisibleStep(WIZARD_SECOND_STEP));
            }
            if (step === WIZARD_FIRST_STEP) {
                if (!fileINEDocument) {
                    dispatch(getOverdraftInitTinTae())
                }
            } else if (step === WIZARD_SECOND_STEP) {
                dispatch({
                    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_VALIDATE_NEW_STEP,
                    payload: {
                        step,
                        validStep: WIZARD_FIRST_STEP

                    }
                });
                dispatch(setVisibleStep(WIZARD_THIRD_STEP));
                !sendMail && dispatch(sendOverDraftSimpleEmail());
                !operationProcessIdInitContract && dispatch(getOverdraftInitContract());
            }

        }
    } else {
        dispatch({
            type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_VALIDATE_STEP,
            payload: {
                step
            }
        });
        const valid = getState().creditPregrantedLimitVariation.getIn(['steps', 0, 'valid']);

        if (valid) {
            dispatch(setVisibleStep(WIZARD_SECOND_STEP));
        }
    }
}
const setWillCancel = willCancel => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_WILL_CANCEL,
    payload: {
        willCancel
    }
})

const clear = () => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_CLEAR
})

const changeLimitRequest = () => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_REQUEST
})

const changeLimitSuccess = () => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_SUCCESS
})

const changeLimitFailure = error => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_VARIATION_FAILURE,
    payload: {
        error
    }
})

const getAccount = creditId => ({
    type: actionTypes.CREDIT_PREGRANTED_LIMIT_GET_ACCOUNT,
    payload: {
        creditId
    }
})
const setNewLimit = (accountId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immAccount = getState().creditsPregranted.getIn(['byId', accountId]);
        const creditPregrantedLimitVariationFeatureFlag = getState().flagBasedFeatures
        const immCreditPregrantedLimitVariation = getState().creditPregrantedLimitVariation;
        const newFF = creditPregrantedLimitVariationFeatureFlag.get(NOT_ALLOWED_NEW_OVERDRAFT_LIMIT_CHANGE_COUNTRIES)
        const acceptanceText = __CONTACT_CENTER__ && !isPrintOfficeMode() ? NA
            : __CONTACT_CENTER__ && isPrintOfficeMode() ? formatText('hireCardOpenCreditStepPolicy-titlePdfWP')
                : formatText('hireCreditCard-textInfoIneDir')

        let params
        if (newFF) {

            params = {
                header: {
                    version: 2,
                },
                query: {
                    tokenFirma: dataToken,
                    acceptanceText,
                    scrollDown: immCreditPregrantedLimitVariation.get('scrollDownPolicy'),
                    operationProcessId: immCreditPregrantedLimitVariation.get('operationProcessIdInitContract'),
                    documentId: immCreditPregrantedLimitVariation.get('filePolicyDocumentId'),
                    acceptanceText: acceptanceText,
                    datosConexion: {
                        contrato: {
                            numerodecontrato: immAccount.get('contractNumber'),
                            producto: immAccount.get('product')
                        }
                    },
                    datosVariacion: {
                        moneda: immAccount.getIn(['available', 'currency']),
                        nuevoImporteLimite: immCreditPregrantedLimitVariation.get('newLimit'),
                        fechaAlta: immAccount.getIn(['details', 'effectiveDate']),
                        subtipoProducto: {
                            subtipodeproducto: immAccount.get('productSubtype'),
                            tipodeproducto: {
                                tipodeproducto: immAccount.get('newProduct')
                            }
                        },
                        horaModificacion: immAccount.getIn(['details', 'hour']),
                        inicioValidez: immAccount.getIn(['details', 'startingDate']),
                        fecha: immAccount.getIn(['details', 'originalDate']),
                        finValidez: immAccount.getIn(['details', 'originalDate']),
                        fechaActualizacion: immAccount.getIn(['details', 'originalDate']),
                        contratoSeleccionado: {
                            numerodecontrato: immAccount.get('contractNumber'),
                            producto: immAccount.get('product')
                        }
                    },
                }
            };
        } else {

            params = {
                query: {
                    tokenFirma: dataToken,
                    documentId: immCreditPregrantedLimitVariation.get('filePolicyDocumentId'),
                    datosConexion: {
                        contrato: {
                            numerodecontrato: immAccount.get('contractNumber'),
                            producto: immAccount.get('product')
                        }
                    },
                    datosVariacion: {
                        moneda: immAccount.getIn(['available', 'currency']),
                        nuevoImporteLimite: immCreditPregrantedLimitVariation.get('newLimit'),
                        fechaAlta: immAccount.getIn(['details', 'effectiveDate']),
                        subtipoProducto: {
                            subtipodeproducto: immAccount.get('productSubtype'),
                            tipodeproducto: {
                                tipodeproducto: immAccount.get('newProduct')
                            }
                        },
                        horaModificacion: immAccount.getIn(['details', 'hour']),
                        inicioValidez: immAccount.getIn(['details', 'startingDate']),
                        fecha: immAccount.getIn(['details', 'originalDate']),
                        finValidez: immAccount.getIn(['details', 'originalDate']),
                        fechaActualizacion: immAccount.getIn(['details', 'originalDate']),
                        contratoSeleccionado: {
                            numerodecontrato: immAccount.get('contractNumber'),
                            producto: immAccount.get('product')
                        }
                    },
                }
            };
        }

        dispatch(changeLimitRequest());
        APIPost(dispatch, apiURLBuilder.getURL('pregrantedCreditLimitVariation'), params)
            .then(response => dispatch(changeLimitSuccess(response)))
            .catch(error => dispatch(changeLimitFailure(error)));
    };

    return Promise.resolve().then(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}
const checkRadioButton = (check) => (dispatch, getState) => {
    dispatch(overdraftCheckedRadioButton(check));
}
function printDocumentPolicy() {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_PRINT_POLICY,
    };
}
function scrollDocumentPolicy() {
    return {
        type: actionTypes.CREDIT_PREGRANTED_LIMIT_SCROLL_POLICY,
    };
}

module.exports = {
    setLimit,
    setNewFFLimit,
    setVisibleStep,
    validateStep,
    setWillCancel,
    setNewLimit,
    clear,
    getAccount,
    overdraftPrintInit,
    checkRadioButton,
    printDocumentPolicy,
    scrollDocumentPolicy,
    onHandleChangeCheckBoxCC,
    preGrantedCreditVariationUpdateConfirmationCheckbox,
    sendOverDraftSimpleEmail,
    updateConfirmationCheckbox,
    getOverdraftInitContract
};
